import React, { useEffect, useState } from "react";
import Select from "react-select";
import {Search} from 'lucide-react';
import classes from "./LoanAccount.module.css"
import plus from "../../../Assets/plus.svg"
import EyeIcon from "../../../Assets/new-eye.svg"
import DeleteIcon from "../../../Assets/new-delete.svg"
import PencilIcon from "../../../Assets/pencil.svg"
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import HeaderNav from "../../Accoungting/HeaderNav/HeaderNav";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../Components/Styles/API/API";
import Swal from "sweetalert2";
import axios from "axios";


const LoanAccount = () => {
   const navigate = useNavigate();
  const [selectedLoan, setSelectedLoan] = useState('');
  const [loanCode, setLoanCode] = useState('');
  const [loanDescription, setLoanDescription] = useState('');
  const [show, setShow] = useState(false);
  const [accPay, setAccPay] = useState([]);
  const [accRec, setAccRec] = useState([]);
  const [selectedPayables, setSelectedPayables] = useState(null);
  const [recievables, setReceivables] = useState([]);
  // const [accountLoan,setAccountLoan] = useState("")
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const handleShow = () => setShow(true);
  const handleShow1 = (loan) => {
    
    setSelectedLoan(loan.id)
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    const match = accRec.find(
    (item) => item.value === loan.report.id
  );

  setSelectedReportTo(match); 
    setShow1(true);
  }
  const handleShow2 = (loan) => {
 
    setSelectedLoan(loan.id)
    setLoanCode(loan.code);
    setLoanDescription(loan.description);
    const match = accRec.find(
    (item) => item.value === loan.report.id
  );

  setSelectedReportTo(match); 
    setShow2(true);
  }
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [eyeClicked, setEyeClicked] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [trashClicked, setTrashClicked] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [admin, setAdmin] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [accountCode1, setAccountCode1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [roless, setRoless] = useState([]);
  const [address, setAddress] = useState("");
  const [office_address, setOfficeAddress] = useState("");
  const [selectedId, setSelectedId] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const [glname, setGlname] = useState("");
  const [glcode1, setGlcode1] = useState("");
  const [glcode, setGlcode] = useState("");
  const [balance, setBalance] = useState("");
  const [selectedDirection, setSelectedDirection] = useState("");
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSubCategory1, setSelectedSubCategory1] = useState('');
  const [glname1, setGlname1] = useState("");
  const [balance1, setBalance1] = useState("");
  const [selectedDirection1, setSelectedDirection1] = useState("");
  const [selectedDate1, setSelectedDate1] = useState('');
  const [selectedChart, setSelectedChart] = useState('')
  const [tableData2, setTableData2] = useState([]);
  // const [glcode, setGlcode] = useState("");
  const [userType, setUserType] = useState('');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [loanLoading, setLoanLoading] = useState(false);
  const [selectedReportTo, setSelectedReportTo] = useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [openNav,setOpenNav] = useState(false);

  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value2 = await localStorage.getItem('permissions');
      const value3 = await localStorage.getItem('admin');
      const admins = await localStorage.getItem('admin');
      const continentName = await localStorage.getItem('continent');
      const regionName = await localStorage.getItem('region');
      const provinceName = await localStorage.getItem('province');

      if (value !== null) {
        setBearer(value);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value2 !== null) {
        setPermissions(value2);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
      if (admins !== null) {
        setUserType(admins);
      }
      if (continentName !== null) {
        setContinent(continentName);
      }
      if (regionName !== null) {
        setRegion(regionName);
      }
      if (provinceName !== null) {
        setProvince(provinceName);
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };



  const fetchData = async () => {
    setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const results = response.data?.data;
      console.log(results);
      setTableData(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setTableData([]);
      }
    } finally {
      setRoleLoading(false);
    }
  };




  useEffect(() => {
    if (bearer) {
      fetchData();
    }
  }, [bearer]);



  const createAccount = async () => {
 setLoanCode('');
      setLoanDescription('');
    setLoanLoading(true);
    try {

      const response = await axios.post(`${BASE_URL}/account/create-loan-account`,
        {
          code: loanCode,
          description: loanDescription,
          // opening_balance: balance,
          report_to: selectedReportTo?.value,
          // payable: selectedPayables?.value,
          type: 2

        },
        { headers }
      );
      console.log(response.data.message)
      fetchData();
      setLoanCode('');
      setLoanDescription('');
      setBalance('');
      setSelectedReportTo(null);
      setSelectedPayables(null);
      handleClose();
      // return
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      console.log(response.data);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setLoanLoading(false);
    }
  }

  const editLoan = async () => {

    setLoanLoading(true);
    try {

      const response = await axios.post(`${BASE_URL}/account/update-loan-account`,
        {
          code: loanCode,
          description: loanDescription,
          // opening_balance: balance,
          report_to: selectedReportTo?.value || '',
          // payable: selectedPayables?.value || '',
          type: 2,
          id: selectedLoan

        },
        { headers }
      );
      console.log(response.data.message)

      fetchData();
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      // return
      setShow1(false);
      console.log(response.data);

    } catch (error) {

      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: error.response.data.message,
        });
        console.log(errorMessage);
      }
    } finally {
      setLoanLoading(false);
    }
  };

  const deleteLoan = async (loanId) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This loan account will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return; // user canceled

    const response = await axios.post(
      `${BASE_URL}/account/delete-loan-account`,
      { id: loanId },
      { headers }
    );

    Swal.fire({
      icon: "success",
      title: "Deleted",
      text: response.data.message,
    });

    fetchData(); // refresh list
  } catch (error) {
    let errorMessage = "Unable to delete loan.";

    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    Swal.fire({
      icon: "error",
      title: "Failed",
      text: errorMessage,
    });

    console.log(errorMessage);
  }
};


  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  const handleValueChange = (value, name, values) => {
    setBalance(value);

  };

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }




  // const filteredData = tableData?.filter(item => item?.description.toLowerCase().includes(searchTerm.toLowerCase()));

  const totalPages = Math.ceil(tableData.length / entriesPerPage);

  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  const totalEntries = tableData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);
  // const displayedData = tableData.slice(startIndexx - 1, endIndexx);


  const handleEyeClick = (id) => {

    const foundCharts = tableData.find(item => item.id === id);
    const chartId = foundCharts.id;
    setSelectedChart(chartId)

    const { code, description, interest, opening_balance } = foundCharts;
    setSelectedLoan(id);
    setLoanCode(code || '');
    setLoanDescription(description || '');
    setBalance(opening_balance || '');
    // const selectedRole = roles.length > 0 ? roles[0].id : '';
    // setSelectedRole(selectedRole);

    setShow1(true);
    setEyeClicked(true);
  };

  // useEffect(() => {

  // }, { selectedChart }

  // )

   useEffect(() => {
  // Your effect code here
}, [selectedChart]);

  const fetchAcReceivables = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/get-loans-receivables`, { headers });
      const accs = response.data?.data;
      console.log("lists:", response);
      const accOptions = accs.map(item => ({
        label: item.gl_name,
        value: item.id
      }));

      setAccRec(accOptions);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setAccRec([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAcPayables = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
      const pay = response.data?.data;
      console.log("lists:", response);
      const payOptions = pay.map(item => ({
        label: item.gl_name,
        value: item.id
      }));

      setAccPay(payOptions);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setAccPay([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchAcReceivables();
      fetchAcPayables();
    }
  }, [bearer]);



  const editUser = async (id) => {
    setUpdateLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/users/update-user`,
        {
          name: fullName1,
          id: selectedId,
          email: email1,
          phone_no: phone1,
          role: selectedRole1,
          user_id: selectedUser
        },
        { headers }
      );

      fetchData();
      handleClose1();
      // toast.success(response.data.message);
      // console.log(response.data);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        // toast.error(errorMessage);
        console.log(error);
      }
    } finally {
      setUpdateLoading(false);
    }
  };


  const handleTrashClick = async (id) => {
    const confirmed = await Swal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this role.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel',
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    try {
      const response = await axios.get(`${BASE_URL}/account/delete?id=${id}`, { headers });
      fetchData();
      // toast.success(response.data.message);
      setTrashClicked(true);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        // toast.error(errorMessage)
        console.log(errorMessage);
      }
    }
  };

  const handleDirectionChange = (e) => {
    setSelectedDirection(e.target.value);
  };
  const handleDirectionChange1 = (e) => {
    setSelectedDirection1(e.target.value);
  };

  const handleValueChange1 = (value1, name1, values1) => {
    setBalance1(value1); // Update the balance state
    console.log(value1, name1, values1);
  };

 const handleExcelExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      tableData.map((item, index) => ({
        "S/N": index + 1,
        "Code": item.code,
        "Description": item.description,
        "Report To": item.report?.gl_name || "",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "table-data.xlsx");
  };

  const handlePDFExport = () => {
    const doc = new jsPDF();
    const tableColumn = ["S/N", "Code", "Description", "Report To"];
    const tableRows = tableData.map((item, index) => [
      index + 1,
      item.code,
      item.description,
      item.report?.gl_name || "",
    ]);

    doc.text("Table Data", 14, 10);
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });
    doc.save("table-data.pdf");
  };

  const handlePrint = () => {
    window.print();
  };

  const filteredTableData = tableData.filter((loan) => {
  const term = searchTerm.toLowerCase();

  // Search by code, description, or report.gl_name
  return (
    loan.code.toLowerCase().includes(term) ||
    loan.description.toLowerCase().includes(term) ||
    loan.report?.gl_name.toLowerCase().includes(term)
  );
});


        
  return (
    <div >
        <HeaderNav />
      
        <Modal show={show} onHide={handleClose} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Create loan Account</Modal.Title>
  </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label style={{ marginTop: 20 }}>Loan Code</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Loan Code"
              value={loanCode}
              onChange={(e) => setLoanCode(e.target.value)}
            />

            <Form.Label style={{ marginTop: 20 }}>Description</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Description"
              value={loanDescription}
              onChange={(e) => setLoanDescription(e.target.value)}
            />

            <Form.Label style={{ marginTop: 20 }}>Account Receivables</Form.Label>
            <Select
              loading={isLoading}
              options={accRec}
              onChange={setSelectedReportTo}
              // value={selectedReportTo}
              placeholder="Select Account Receivables"
              styles={{ container: (base) => ({ ...base, marginTop: 5 }) }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

  <Modal.Footer>
    <Button variant="danger" onClick={handleClose}>
      Go back
    </Button>
    <Button className={classes.customButton} onClick={createAccount}>
   {loanLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: "5px" }}>Creating account, Please wait...</span>
        </>
      ) : (
        "Create"
      )}
    </Button>
    {/* <Button variant="success" onClick={"createAccount"}>
      {loanLoading ? (
        <>
          <Spinner size="sm" />
          <span style={{ marginLeft: "5px" }}>Creating account, Please wait...</span>
        </>
      ) : (
        "Create"
      )}
    </Button> */}
  </Modal.Footer>
</Modal>
<Modal show={show1} onHide={handleClose1} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>Update Loan Accounts</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label style={{ marginTop: 20 }}>Loan Code</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Loan Code"
          value={loanCode}
          onChange={(e) => setLoanCode(e.target.value)}
        />

        <Form.Label style={{ marginTop: 20 }}>Description</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Description"
          value={loanDescription}
          onChange={(e) => setLoanDescription(e.target.value)}
        />

        {/* <Form.Label style={{ marginTop: 20 }}>Balance</Form.Label>
        <CurrencyInput
          name="balance"
          decimalsLimit={2}
          className="form-control"
          style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
        /> */}

        <Form.Label style={{ marginTop: 20 }}>Account Receivables</Form.Label>
        <Select
          loading={isLoading}
           options={accRec}
          onChange={setSelectedReportTo}
          value={selectedReportTo}
          placeholder="Select Account Receivables"
        />

        {/* <Form.Label style={{ marginTop: 20 }}>Account Payables</Form.Label>
        <Select
          loading={isLoading}
          options={accPay}
          onChange={setSelectedPayables}
          value={selectedPayables}
          placeholder="Select Account Payables"
        /> */}
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="danger" onClick={handleClose1}>
      Go back
    </Button>
    {/* <Button className={classes.customButton} onClick={editLoan}>
     Save Changes
    </Button> */}
    <Button variant="success" onClick={editLoan} className={classes.customButton}>
      {loanLoading ? <Spinner id="loader" animation="border" variant="warning" /> : 'Save Changes'}
    </Button>
  </Modal.Footer>
</Modal>
<Modal show={show2} onHide={handleClose2} animation={false}>
  <Modal.Header closeButton>
    <Modal.Title>View Loan Accounts</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label style={{ marginTop: 20 }}>Loan Code</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Loan Code"
          value={loanCode}
          onChange={(e) => setLoanCode(e.target.value)}
        />

        <Form.Label style={{ marginTop: 20 }}>Description</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter Description"
          value={loanDescription}
          onChange={(e) => setLoanDescription(e.target.value)}
        />

        {/* <Form.Label style={{ marginTop: 20 }}>Balance</Form.Label>
        <CurrencyInput
          name="balance"
          decimalsLimit={2}
          className="form-control"
          style={{ textAlign: "right", border: "1px solid #e4e4e4", backgroundColor: "none" }}
        /> */}

        <Form.Label style={{ marginTop: 20 }}>Account Receivables</Form.Label>
        <Select
          loading={isLoading}
           options={accRec}
          onChange={setSelectedReportTo}
          value={selectedReportTo}
          placeholder="Select Account Receivables"
        />

        {/* <Form.Label style={{ marginTop: 20 }}>Account Payables</Form.Label>
        <Select
          loading={isLoading}
          options={accPay}
          onChange={setSelectedPayables}
          value={selectedPayables}
          placeholder="Select Account Payables"
        /> */}
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
  </Modal.Footer>
</Modal>


        <div className={classes.topContainer}>
          <div className={classes.topNavBars}>
            <Button className={classes.buttonsNav}>Remitances</Button>
            <Button className={classes.buttonsNav}>Petty Cash</Button>
            <Button className={classes.buttonsNav}>Supplier's Payment</Button>
            <Button className={classes.buttonsNav}>Customer's Leger</Button>
          </div>
          <div style={{marginTop: 24}}/>
            <h3 className={classes.topText}>Loan Account</h3>
            <p className={classes.prgText}>Add, Upload, View, Edit, and Delete Loan Account.</p>
            <div className={classes.subContainer}>
                <div className={classes.searchInputWrapper}>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className={classes.searchInput}
                                    placeholder="Search accounts..."
                                />
                                <Search className={classes.searchIcon} size={16} />
                            </div>
                            <div className={classes.statCount}>
                              <div className={classes.statConn}>
                              <p className={classes.txtHd}>Loan Accounts</p>
                              <p className={classes.txtHds}>{tableData.length ?? 0}</p>
                              </div>
                            </div>
                            <div>
  <button className={classes.loanBtn} onClick={handleShow}>
    <img src={plus} alt="plus" /> Create Loan Account
  </button>
</div>

            </div>
            <div className={classes.tableContainer}>
          <table className={classes.tableTable}>
  <thead className={classes.tableHeader}>
    <tr>
      <th>#</th>
      <th>Code</th>
      <th>Description</th>
      <th>Report To</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {filteredTableData.map((loan, index) => (
      <tr key={index}>
        <td className={classes.textby}>{index + 1}</td>
        <td className={classes.textby}>{loan.code}</td>
       <td className={classes.textby}>
  <span
    className={classes.statucColor}
    // style={loan.description}
  >
    {loan.description}
  </span>
</td>


        <td className={classes.textby}>{loan.report?.gl_name}</td>
        <td className={classes.btnAction}>
          <button
  style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
  onClick={() => handleShow2(loan)} 
>
  <img src={EyeIcon}/>
</button>
          <button
  style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
  onClick={() => handleShow1(loan)} 
>
  <img src={PencilIcon}/>
</button>

          <button
            style={{ backgroundColor: "transparent", border: 0, cursor: "pointer" }}
             onClick={() => deleteLoan(loan.id)}
          >
            <img src={DeleteIcon}/>
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
<div className={classes.paginationStyle}>
  {/* <div className={classes.footerSubOne}>
    <button className={classes.btnFirst}>First</button>
    
    <span className={classes.ftOne}>
      <button className={`${classes.pageNumber} ${classes.active}`}>1</button>
      <button className={classes.pageNumber}>2</button>
    </span>

    <button className={classes.btnSec}>Last</button>
  </div>
  <p className={classes.displayPag}>Displaying 1-41 of 41</p> */}
</div>



            </div>
        </div>
    </div>
  )
}

export default LoanAccount